import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { login, register, setAuthToken, logout } from "../userApi";

export function useAuth() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleLogin = async (email, password) => {
    try {
      setIsLoading(true);
      setError(null);
      const response = await login(email, password);

      // Stocker le token et les informations utilisateur
      setAuthToken(response.token);
      localStorage.setItem("user", JSON.stringify({
        email: response.email,
        roles: response.roles
      }));
      
      navigate("/dashboard");
      return true;
    } catch (err) {
      setError(err.message || "Erreur lors de la connexion");
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  // const handleRegister = async (userData) => {
  //   try {
  //     setIsLoading(true);
  //     setError(null);
  //     const response = await register(userData);
      
  //     // Stocker le token et les informations utilisateur
  //     setAuthToken(response.token);
  //     localStorage.setItem("user", JSON.stringify({
  //       username: response.username,
  //       roles: response.roles
  //     }));
      
  //     navigate("/dashboard");
  //     return true;
  //   } catch (err) {
  //     setError(err.message || "Erreur lors de l'inscription");
  //     return false;
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return {
    isLoading,
    error,
    handleLogin,
    // handleRegister,
    handleLogout
  };
}
